import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { auth, firestore } from '../firebaseConfig';
import { collection, doc, getDoc, getDocs, query, where, limit } from 'firebase/firestore';
import {
  MdDashboard,
  MdApproval,
  MdAssessment,
  MdEventAvailable,
  MdAccountTree,
  MdLocationOn,
  MdPerson,
  MdNotifications,
  MdSecurity,
  MdStorefront,
  MdLogout,
  MdPersonAdd,
  MdEmojiEvents
} from 'react-icons/md';
import './Sidebar.css';

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();
  const { pathname } = location;

  const [role, setRole] = useState('user');

  useEffect(() => {
    const fetchRole = async () => {
      try {
        const user = auth.currentUser;
        if (!user) return;

        // Try by uid first
        const byUidRef = doc(firestore, 'adminusers', user.uid);
        const byUidSnap = await getDoc(byUidRef);
        if (byUidSnap.exists()) {
          const data = byUidSnap.data();
          if (data?.role) setRole(String(data.role).toLowerCase());
          return;
        }

        // Fallback: query by email
        if (user.email) {
          const q = query(
            collection(firestore, 'adminusers'),
            where('email', '==', user.email),
            limit(1)
          );
          const snap = await getDocs(q);
          if (!snap.empty) {
            const data = snap.docs[0].data();
            if (data?.role) setRole(String(data.role).toLowerCase());
          }
        }
      } catch (e) {
        // Silent fail -> default role stays 'user'
      }
    };

    fetchRole();
  }, []);

  // Close sidebar when a link is clicked (for mobile)
  const handleLinkClick = () => {
    if (window.innerWidth <= 768) {
      onClose();
    }
  };

  const handleLogout = () => {
    auth.signOut().then(() => {
      console.log("User signed out");
    }).catch((error) => {
      console.error("Error signing out: ", error);
    });
  };

  return (
    <>
      {/* Mobile overlay */}
      <div className={`sidebar-overlay ${isOpen ? 'active' : ''}`} onClick={onClose}></div>
      
      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h2 className="text-white text-xl font-bold">Admin Panel</h2>
        </div>

      <nav className="sidebar-nav">
        <ul>
          <li className={pathname === '/' ? 'active' : ''}>
            <Link to="/" className="sidebar-link" onClick={handleLinkClick}>
              <MdDashboard className="sidebar-icon" />
              <span>Dashboard</span>
            </Link>
          </li>
          <li className={pathname === '/approvals' ? 'active' : ''}>
            <Link to="/approvals" className="sidebar-link" onClick={handleLinkClick}>
              <MdApproval className="sidebar-icon" />
              <span>Approvals</span>
            </Link>
          </li>
          <li className={pathname === '/reports' ? 'active' : ''}>
            <Link to="/reports" className="sidebar-link" onClick={handleLinkClick}>
              <MdAssessment className="sidebar-icon" />
              <span>Reports</span>
            </Link>
          </li>
          <li className={pathname === '/inventory' ? 'active' : ''}>
            <Link to="/inventory" className="sidebar-link" onClick={handleLinkClick}>
              <MdStorefront className="sidebar-icon" />
              <span>Inventory</span>
            </Link>
          </li>
          <li className={pathname === '/attendance-report' ? 'active' : ''}>
            <Link to="/attendance-report" className="sidebar-link" onClick={handleLinkClick}>
              <MdEventAvailable className="sidebar-icon" />
              <span>Daily Attendance Report</span>
            </Link>
          </li>
          <li className={pathname === '/network' ? 'active' : ''}>
            <Link to="/network" className="sidebar-link" onClick={handleLinkClick}>
              <MdAccountTree className="sidebar-icon" />
              <span>Network</span>
            </Link>
          </li>
          <li className={pathname === '/leaderboard' ? 'active' : ''}>
            <Link to="/leaderboard" className="sidebar-link" onClick={handleLinkClick}>
              <MdEmojiEvents className="sidebar-icon" />
              <span>Leaderboard</span>
            </Link>
          </li>
          <li className={pathname === '/onboarding' ? 'active' : ''}>
            <Link to="/onboarding" className="sidebar-link" onClick={handleLinkClick}>
              <MdPersonAdd className="sidebar-icon" />
              <span>Onboarding</span>
            </Link>
          </li>
          <li className={pathname === '/notifications' ? 'active' : ''}>
            <Link to="/notifications" className="sidebar-link" onClick={handleLinkClick}>
              <MdNotifications className="sidebar-icon" />
              <span>Notifications</span>
            </Link>
          </li>
          <li className={pathname === '/live-tracking' ? 'active' : ''}>
            <Link to="/live-tracking" className="sidebar-link" onClick={handleLinkClick}>
              <MdLocationOn className="sidebar-icon" />
              <span>Live Tracking</span>
            </Link>
          </li>
          <li className={pathname === '/compliance' ? 'active' : ''}>
            <Link to="/compliance" className="sidebar-link" onClick={handleLinkClick}>
              <MdSecurity className="sidebar-icon" />
              <span>Compliance</span>
            </Link>
          </li>
          <li className={pathname === '/profile' ? 'active' : ''}>
            <Link to="/profile" className="sidebar-link" onClick={handleLinkClick}>
              <MdPerson className="sidebar-icon" />
              <span>Profile</span>
            </Link>
          </li>
        </ul>
      </nav>

      <div className="logout-container">
        <button onClick={handleLogout} className="logout-button">
          <MdLogout className="sidebar-icon" />
          <span>Logout</span>
        </button>
      </div>
      </div>
    </>
  );
};

export default Sidebar;
